import { omit } from 'lodash';

export const setBlockQuestions = (
  questions: any,
  item: any,
  block: any,
  blockQuestionIndex: any,
) => {
  let updatedQuestions = [];

  if (item.id === 'rating') {
    const question = questions.find(
      (q: any) => q.name === block.question_names[0],
    );

    const nextPostion =
      Math.max.apply(
        Math,
        questions.map((o: any) => o.position),
      ) + 1;

    const nextQuestions = [
      ...questions,
      {
        ...omit(question, ['id']),
        name: `${block.question_names[0]}1`,
        position: nextPostion + 1,
        type_info: {
          ...question.type_info,
          meta: {
            ...omit(question.type_info.meta, ['block']),
          },
        },
      },
      {
        ...omit(question, ['id']),
        name: `${block.question_names[0]}2`,
        position: nextPostion + 2,
        type_info: {
          ...question.type_info,
          meta: {
            ...omit(question.type_info.meta, ['block']),
          },
        },
      },
    ];
    // const { min, max } =
    //   surveyForm?.question_details?.questions[0].type_info?.validation;

    updatedQuestions = nextQuestions.map((q: any, i: number) => {
      return i === 0
        ? {
            ...q,
            type_info: {
              ...q.type_info,
              choices: q.type_info.choices.map((c: any) => {
                return {
                  ...c,
                  dependent_question_names: [
                    ...(c.dependent_question_names || []),
                    c.value > 8
                      ? block.question_names[0]
                      : c.value > 6
                      ? `${block.question_names[0]}1`
                      : `${block.question_names[0]}2`,
                  ],
                };
              }),
            },
          }
        : q.name === block.question_names[0]
        ? {
            ...q,
            type_info: {
              ...q.type_info,
              meta: {
                ...q.type_info.meta,
                block: {
                  ...q.type_info.meta.block,
                  question_names: [
                    block.question_names[0],
                    `${block.question_names[0]}1`,
                    `${block.question_names[0]}2`,
                  ],
                },
              },
            },
          }
        : q;
    });
  } else {
    updatedQuestions = questions
      .filter(
        (q: any) =>
          q.name !== `${block.question_names[0]}1` &&
          q.name !== `${block.question_names[0]}2`,
      )
      .map((q: any, i: number) => {
        return i === 0
          ? {
              ...q,
              type_info: {
                ...q.type_info,
                choices: q.type_info.choices.map((c: any) => {
                  return {
                    ...c,
                    dependent_question_names: [
                      ...(c.dependent_question_names || []).filter(
                        (dependent_question_name: String) =>
                          block.question_names.indexOf(
                            dependent_question_name,
                          ) === -1,
                      ),
                    ],
                  };
                }),
              },
            }
          : q;
      });
  }

  updatedQuestions[blockQuestionIndex].type_info.meta.block.is_based_on_rating =
    item.id === 'rating';

  return updatedQuestions;
};
